import { defaultDeprecatedTraceTagsMap, transformDeprecatedTags } from '@cvent/sli-nextjs-metrics';

/**
 * By default, the SLI metrics library will add the cvent_ prefix to all attributes/tags before sending the data to
 * datadog. To standardise traces and logs throughout different Cvent products, some general guidelines were
 * introduced in order to have consistency regarding tag names.
 * @see https://wiki.cvent.com/pages/viewpage.action?spaceKey=RD&title=Tracing+Standards for the complete list of naming
 * conventions and standard Cvent tags to use.
 * We're going to transform the current data to follow these conventions while also adding the cvent_ prefix to keep
 * backwards compatibility for a while until the SLIs in Admin Portal/Backstage are migrated.
 *
 * @param data The data we want to transform
 * @param attributesToIgnore A list of data attributes/properties we want to ignore during the transformation
 */
const transformDeprecatedDatadogTags = (
  data: Record<string, unknown>,
  attributesToIgnore: string[] = []
): Record<string, unknown> => {
  return transformDeprecatedTags(data, attributesToIgnore, defaultDeprecatedTraceTagsMap);
};

export default transformDeprecatedDatadogTags;
